export default __webpack_public_path__ + "static/media/section-loader.6f132856.gif";